import { render, staticRenderFns } from "./addIssuer.vue?vue&type=template&id=10d30b28&scoped=true&"
import script from "./addIssuer.vue?vue&type=script&lang=js&"
export * from "./addIssuer.vue?vue&type=script&lang=js&"
import style0 from "./addIssuer.vue?vue&type=style&index=0&id=10d30b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d30b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d30b28')) {
      api.createRecord('10d30b28', component.options)
    } else {
      api.reload('10d30b28', component.options)
    }
    module.hot.accept("./addIssuer.vue?vue&type=template&id=10d30b28&scoped=true&", function () {
      api.rerender('10d30b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityDynamicHome/components/addIssuer.vue"
export default component.exports